import React from 'react'
import PaymentFormRow from './rows/PaymentFormRow';
import AccountRenewalFormRow from './rows/AccountRenewalFormRow';
import PurchaseHistoryRow from './rows/PurchaseHistoryRow';

const AccountSettingsForm = () => {
    return (
        <>
            <PaymentFormRow />
            <AccountRenewalFormRow />
            <PurchaseHistoryRow />
        </>
    )
}

export default AccountSettingsForm
